module.exports = __webpack_public_path__ + "img/7.7063b787.png";